import { render } from "./tableCustomerRow.vue?vue&type=template&id=3a42c77d"
import script from "./tableCustomerRow.vue?vue&type=script&lang=js"
export * from "./tableCustomerRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__